
export function setToken(token) {
    return localStorage.setItem("token-TjJKneJHsd",token)
}

export function getToken() {
    return localStorage.getItem("token-TjJKneJHsd")
}